import React from "react";
import "./faq.css";

const FAQ = () => {
  return (
    <section className="faq-section ">
      <div class="wrapper bg-white rounded shadow">
        <div class="h2 text-center fw-bold">
          Frequently Asked Questions (FAQs)
        </div>
        <br />
        <div class="accordion accordion-flush " id="myAccordion">
          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingOne">
              <button
                class="accordion-button collapsed border-0"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseOne"
                aria-expanded="false"
                aria-controls="flush-collapseOne"
              >
                Who can become a PrepAI affiliate?
              </button>
            </h2>
            <div
              id="flush-collapseOne"
              class="accordion-collapse collapse border-0"
              aria-labelledby="flush-headingOne"
              data-bs-parent="#myAccordion"
            >
              <div className="pad">
                <span style={{ fontSize: "15px" }}>
                  Anyone with an interest in promoting our API solutions and
                  earning commissions can become a PrepAI affiliate. The program
                  is open to a diverse range of individuals, whether you have a
                  blog, website, or a strong online presence, becoming a PrepAI
                  affiliate is an accessible opportunity for those who want to
                  support the assessment revolution and make extra income.
                </span>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingOne">
              <button
                class="accordion-button collapsed border-0"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseTwo"
                aria-expanded="false"
                aria-controls="flush-collapseTwo"
              >
                What is the commission structure like?
              </button>
            </h2>
            <div
              id="flush-collapseTwo"
              class="accordion-collapse collapse border-0"
              aria-labelledby="flush-headingOne"
              data-bs-parent="#myAccordion"
            >
              <div className="pad">
                <span style={{ fontSize: "15px" }}>
                  Our commission structure is designed to be transparent and
                  rewarding. You'll earn a commission for every new paid
                  subscriber/B2B customer you refer. The more referrals you
                  bring in, the more you earn. It's a simple and fair way to
                  maximize your earnings as an affiliate. Your commissions are
                  tied to subscription and lifetime deal ensuring that you're
                  fairly compensated for each new paying customer you bring to
                  PrepAI.
                </span>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingOne">
              <button
                class="accordion-button collapsed border-0"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseThree"
                aria-expanded="false"
                aria-controls="flush-collapseThree"
              >
                Is there a cost associated with joining the affiliate program?
              </button>
            </h2>
            <div
              id="flush-collapseThree"
              class="accordion-collapse collapse border-0"
              aria-labelledby="flush-headingOne"
              data-bs-parent="#myAccordion"
            >
              <div className="pad">
                <span style={{ fontSize: "15px" }}>
                  No, there is no registration/joining fee in the PrepAI
                  affiliate program. It's completely free, and you can start
                  earning commissions without any upfront expenses.
                </span>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingOne">
              <button
                class="accordion-button collapsed border-0"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseFour"
                aria-expanded="false"
                aria-controls="flush-collapseFour"
              >
                How can I promote PrepAI as an affiliate?
              </button>
            </h2>
            <div
              id="flush-collapseFour"
              class="accordion-collapse collapse border-0"
              aria-labelledby="flush-headingOne"
              data-bs-parent="#myAccordion"
            >
              <div className="pad">
                <span style={{ fontSize: "15px" }}>
                  We provide you with a unique affiliate link that you can
                  incorporate into your blog posts, videos, articles, emails,
                  and various digital content channels. This link allows us to
                  track your referrals and ensure you receive your commissions
                  for successful leads.
                </span>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingOne">
              <button
                class="accordion-button collapsed border-0"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseFive"
                aria-expanded="false"
                aria-controls="flush-collapseFive"
              >
                What kind of support can I expect as an affiliate?
              </button>
            </h2>
            <div
              id="flush-collapseFive"
              class="accordion-collapse collapse border-0"
              aria-labelledby="flush-headingOne"
              data-bs-parent="#myAccordion"
            >
              <div className="pad">
                <span style={{ fontSize: "15px" }}>
                  As a PrepAI affiliate, you can count on our dedicated support
                  team to assist you in your affiliate journey. We offer
                  resources, training, and responsive assistance to help you
                  make the most of this opportunity and grow as an affiliate.
                  We're here to ensure your financial success.
                </span>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingSix">
              <button
                class="accordion-button collapsed border-0"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseSix"
                aria-expanded="false"
                aria-controls="flush-collapseSix"
              >
                How quickly can I start earning after signing up?
              </button>
            </h2>
            <div
              id="flush-collapseSix"
              class="accordion-collapse collapse border-0"
              aria-labelledby="flush-headingSix"
              data-bs-parent="#myAccordion"
            >
              <div className="pad">
                <span style={{ fontSize: "15px" }}>
                  We kept our registration and onboarding process very smooth
                  and quick. Once you register, you can start sharing your
                  unique referral link immediately. Commissions begin rolling in
                  as soon as your referrals convert to paying users, often
                  within days.
                </span>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingSeven">
              <button
                class="accordion-button collapsed border-0"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseSeven"
                aria-expanded="false"
                aria-controls="flush-collapseSeven"
              >
                What makes PrepAI's affiliate program stand out from others?
              </button>
            </h2>
            <div
              id="flush-collapseSeven"
              class="accordion-collapse collapse border-0"
              aria-labelledby="flush-headingSeven"
              data-bs-parent="#myAccordion"
            >
              <div className="pad">
                <span style={{ fontSize: "15px" }}>
                  PrepAI offers a transparent commission structure, fast
                  payouts, bonus incentives, and <strong>24/7</strong> dedicated
                  support, designed to make earning simple, reliable, and
                  rewarding for you.
                </span>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingEight">
              <button
                class="accordion-button collapsed border-0"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseEight"
                aria-expanded="false"
                aria-controls="flush-collapseEight"
              >
                How much can I earn as a PrepAI affiliate?
              </button>
            </h2>
            <div
              id="flush-collapseEight"
              class="accordion-collapse collapse border-0"
              aria-labelledby="flush-headingEight"
              data-bs-parent="#myAccordion"
            >
              <div className="pad">
                <span style={{ fontSize: "15px" }}>
                  With standard commissions, Fast Start bonuses (up to{" "}
                  <strong>$300</strong> in your first 30 days), and monthly
                  bonuses (up to <strong>$400</strong>), some affiliates can
                  earn up to <strong>$3000/month</strong> or more over time,
                  depending on their level of activity in promoting the platform
                  with the PrepAI Affiliate Program.
                </span>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingNine">
              <button
                class="accordion-button collapsed border-0"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseNine"
                aria-expanded="false"
                aria-controls="flush-collapseNine"
              >
                Is there a limit to the number of people I can refer?
              </button>
            </h2>
            <div
              id="flush-collapseNine"
              class="accordion-collapse collapse border-0"
              aria-labelledby="flush-headingNine"
              data-bs-parent="#myAccordion"
            >
              <div className="pad">
                <span style={{ fontSize: "15px" }}>
                  Not at all! There's no cap on your referrals or earnings. The
                  more users you bring in with your network, the more you
                  benefit via commissions, bonus payouts, and stable passive
                  income.
                  <br />
                  <br />
                  Refer <strong>5-9</strong> users in a month and get a{" "}
                  <strong>$100</strong> bonus.
                  <br />
                  Refer <strong>10-20</strong> users in a month and earn{" "}
                  <strong>$200</strong> bonus.
                  <br />
                  Refer <strong>20+</strong> users in a month and enjoy a{" "}
                  <strong>$400</strong> bonus.
                  <br />
                  <br />
                  More users = more rewards for you.
                </span>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="flush-headingTen">
              <button
                class="accordion-button collapsed border-0"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseTen"
                aria-expanded="false"
                aria-controls="flush-collapseTen"
              >
                Can I promote PrepAI across multiple channels?
              </button>
            </h2>
            <div
              id="flush-collapseTen"
              class="accordion-collapse collapse border-0"
              aria-labelledby="flush-headingTen"
              data-bs-parent="#myAccordion"
            >
              <div className="pad">
                <span style={{ fontSize: "15px" }}>
                  Absolutely! Whether it's your{" "}
                  <strong>blog, social media, email list, or website</strong>,
                  you can promote PrepAI anywhere your network or audience is.
                  The more channels you use, the greater your chances of earning
                  commissions quickly and consistently.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
